export default __webpack_public_path__ + "9b86c3c3517abda5e67b9abb58793d30.coffee";